module.exports = __webpack_public_path__ + "media/ecom/LimitedTimeOfferBadge-e3d4e117.svg";